import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchColorDetailsWithoutId } from '../colorDetails/colorDetails.actions';
import { fetchColorMaster } from '../colorMaster/colorMaster.actions';
import { fetchHSNMaster } from '../hsnMaster/hsnMaster.actions';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import { fetchPropertyDataForFabricInfo } from '../stylePreparations/fabricInformation/fabricInformation.action';
import {
    CREATE_YARN_MASTER_FAILURE,
    CREATE_YARN_MASTER_FORM,
    CREATE_YARN_MASTER_REQUEST,
    CREATE_YARN_MASTER_SUCCESS,
    DELETE_YARN_MASTER_FAILURE,
    DELETE_YARN_MASTER_REQUEST,
    DELETE_YARN_MASTER_SUCCESS,
    FETCH_YARN_MASTER_FAILURE,
    FETCH_YARN_MASTER_REQUEST,
    FETCH_YARN_MASTER_SUCCESS,
    FETCH_SINGLE_YARN_MASTER_FAILURE,
    FETCH_SINGLE_YARN_MASTER_REQUEST,
    FETCH_SINGLE_YARN_MASTER_SUCCESS,
    RESET_YARN_MASTER_INFO,
    UPDATE_YARN_MASTER_FAILURE,
    UPDATE_YARN_MASTER_REQUEST,
    UPDATE_YARN_MASTER_SUCCESS,
    FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST,
    FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS,
    FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE,
    FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST,
    FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS,
    FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE,
    FETCH_YARN_MATERIALS_REQUEST,
    FETCH_YARN_MATERIALS_SUCCESS,
    FETCH_YARN_MATERIALS_FAILURE
} from './yarnMaster.actionsType';

// FETCH PART DATA
export let fetchYarnMasterDataDetails = () => {
    let config = {
        method: 'get',
        url: ConstantApi.yarnMasterGET,
        responseTypeRequest: FETCH_YARN_MASTER_REQUEST,
        responseTypeSuccess: FETCH_YARN_MASTER_SUCCESS,
        responseTypeFailure: FETCH_YARN_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE YARN_MASTER FORM
export let createYarnMasterForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_YARN_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE YARN_MASTER
export let createYarnMaster = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        ...formData,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldFKYarnMaterial: parseInt(formData.fldFKYarnMaterial),
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldPurchasePrice: formData?.fldPurchasePrice
            ? formData.fldPurchasePrice.split('.').length >= 2
                ? parseFloat(formData.fldPurchasePrice)
                : parseInt(formData.fldPurchasePrice)
            : 0,
        fldJobworkPrice: formData?.fldJobworkPrice
            ? formData.fldJobworkPrice.split('.').length >= 2
                ? parseFloat(formData.fldJobworkPrice)
                : parseInt(formData.fldJobworkPrice)
            : 0,
        fldProcessPrice: formData?.fldProcessPrice
            ? formData.fldProcessPrice.split('.').length >= 2
                ? parseFloat(formData.fldProcessPrice)
                : parseInt(formData.fldProcessPrice)
            : 0,
        fldFKColorId: formData?.fldFKColorId ? parseInt(formData.fldFKColorId) : 0
    });

    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.yarnMasterPOST}`,
        responseTypeRequest: CREATE_YARN_MASTER_REQUEST,
        responseTypeSuccess: CREATE_YARN_MASTER_SUCCESS,
        responseTypeFailure: CREATE_YARN_MASTER_FAILURE,
        modalClose,
        resetFormData: RESET_YARN_MASTER_INFO,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnMasterDataDetails()
    };
    return axiosCall(config);
};

// GET SINGLE YARN_MASTER
export let getSingleYarnMaster = (userform) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnMasterGETID}/${userform.fldId}`,
        responseTypeRequest: FETCH_SINGLE_YARN_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_YARN_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_YARN_MASTER_FAILURE,
        singlApiArray: [
            fetchPropertyDataForFabricInfo(14), //Yarn Group
            fetchPropertyDataForFabricInfo(15), //Yarn Type
            fetchColorDetailsWithoutId(),
            fetchCommonPropertyById(80), // Yarn Material
            fetchHSNMaster(),
            fetchColorMaster()
        ]
    };
    return axiosCall(config);
};

//UPDATE YARN_MASTER
export let updateYarnMaster = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldFKYarnGroup: parseInt(formData.fldFKYarnGroup),
        fldFKYarnType: parseInt(formData.fldFKYarnType),
        fldFKYarnMaterial: parseInt(formData.fldFKYarnMaterial),
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKColorId: formData?.fldFKColorId ? parseInt(formData.fldFKColorId) : 0,
        fldPurchasePrice: formData?.fldPurchasePrice
            ? formData.fldPurchasePrice.split('.').length >= 2
                ? parseFloat(formData.fldPurchasePrice)
                : parseInt(formData.fldPurchasePrice)
            : 0,
        fldJobworkPrice: formData?.fldJobworkPrice
            ? formData.fldJobworkPrice.split('.').length >= 2
                ? parseFloat(formData.fldJobworkPrice)
                : parseInt(formData.fldJobworkPrice)
            : 0,
        fldProcessPrice: formData?.fldProcessPrice
            ? formData.fldProcessPrice.split('.').length >= 2
                ? parseFloat(formData.fldProcessPrice)
                : parseInt(formData.fldProcessPrice)
            : 0,
        fldModifiedDt: today.toISOString()
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.yarnMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_YARN_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_YARN_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_YARN_MASTER_FAILURE,
        resetFormData: RESET_YARN_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchYarnMasterDataDetails()
    };
    return axiosCall(config);
};

// DELETE YARN_MASTER
export let deleteYarnMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.yarnMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_YARN_MASTER_REQUEST,
        responseTypeSuccess: DELETE_YARN_MASTER_SUCCESS,
        responseTypeFailure: DELETE_YARN_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchYarnMasterDataDetails()
    };
    return axiosCall(config);
};
// yarnMaterial
// DELETE YARN_MASTER
export let YarnMaterials = (groupId, typeId, colorId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnMasterYarnMaterialsGET}?FldFKYarnGroup=${groupId}&FldFKYarnType=${typeId}&FldFKColourId=${colorId}`,
        responseTypeRequest: FETCH_YARN_MATERIALS_REQUEST,
        responseTypeSuccess: FETCH_YARN_MATERIALS_SUCCESS,
        responseTypeFailure: FETCH_YARN_MATERIALS_FAILURE
    };
    return axiosCall(config);
};

// FETCH PART DATA
export let fetchYarnMasterGroupDistinctData = () => {
    let config = {
        method: 'get',
        url: ConstantApi.yarnGroupDistinctGET,
        responseTypeRequest: FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST,
        responseTypeSuccess: FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS,
        responseTypeFailure: FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE
    };
    return axiosCall(config);
};

// FETCH PART DATA
export let fetchYarnMasterTypeDistinctData = (yarnGroupId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.yarnTypeDistinctGET}?YarnGroupId=${yarnGroupId}`,
        responseTypeRequest: FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST,
        responseTypeSuccess: FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS,
        responseTypeFailure: FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE
    };
    return axiosCall(config);
};
